var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import Component from 'vue-class-component';
import { clamp, cloneDeep, debounce, groupBy } from "lodash-es";
import Draggable from 'vuedraggable';
import { BlockContext } from '@lyonbot/interactive-blocks';
import { message } from 'ant-design-vue';
import { INJECT_SIMPLE_FLOW_EDITOR, INJECT_SIMPLE_FLOW_STEP_EDITOR, INJECT_SIMPLE_FLOW_STEP_LIST } from './consts';
import { vueObjectEditorMixin } from "../../../lib/utils/vue";
import FlowAtomSelector from "./FlowAtomSelector";
import SimpleFlowStepList from './SimpleFlowStepList';
import classNames from "../../../lib/utils/classNames";
let SimpleFlowEditor = class SimpleFlowEditor extends Vue {
  get atoms() {
    return this.flowCtxBase.atoms;
  }
  get groupedAtoms() {
    return groupBy(this.atoms, x => x.category);
  }
  get flowSteps() {
    return this.tempValue.steps;
  }
  set flowSteps(v) {
    this.tempValue.steps = v;
  }
  get ibContext() {
    return new BlockContext({
      brand: 'simpleFlow'
    });
  }
  created() {
    this.ibContext.hiddenInput.addEventListener('keydown', event => {
      if (event.code === 'Space') {
        this.ibContext.activeBlocks.forEach(block => {
          var _block$ref;
          (_block$ref = block.ref) === null || _block$ref === void 0 || _block$ref.toggleParams();
        });
        event.preventDefault();
        return;
      }
      if (event.code === 'ArrowLeft' || event.code === 'ArrowRight') {
        const showParams = event.code === 'ArrowRight';
        this.ibContext.activeBlocks.forEach(block => {
          const inst = block.ref;
          if (inst) inst.showParams = showParams;
        });
        event.stopImmediatePropagation();
        return;
      }
      // 按着 Alt + 上下键，可改变顺序
      if (event.altKey && (event.code === 'ArrowUp' || event.code === 'ArrowDown')) {
        var _this$ibContext$activ;
        const delta = event.code === 'ArrowUp' ? -1 : 1;
        const stepListVM = (_this$ibContext$activ = this.ibContext.activeSlot) === null || _this$ibContext$activ === void 0 ? void 0 : _this$ibContext$activ.ref;
        const steps = stepListVM === null || stepListVM === void 0 ? void 0 : stepListVM.steps;
        if (steps) {
          const oldIndexes = Array.from(this.ibContext.activeBlocks, x => x.index).sort((a, b) => (b - a) * delta);
          const newIndexes = [];
          oldIndexes.forEach(index => {
            const newIndex = clamp(index + delta, 0, steps.length - 1);
            newIndexes.push(newIndex);
            if (newIndex === index) return;
            steps.splice(newIndex, 0, ...steps.splice(index, 1));
          });
          this.flushChanges();
          stepListVM.ibSetActiveBlocks(newIndexes);
        }
        event.stopImmediatePropagation();
        return;
      }
      if (event.key === 'Insert') {
        var _this$ibContext$activ2;
        const stepListVM = (_this$ibContext$activ2 = this.ibContext.activeSlot) === null || _this$ibContext$activ2 === void 0 ? void 0 : _this$ibContext$activ2.ref;
        stepListVM === null || stepListVM === void 0 || stepListVM.focusAddStepInput();
        event.preventDefault();
        return;
      }
      if (event.code === 'F2') {
        var _this$ibContext$activ3;
        const inst = (_this$ibContext$activ3 = this.ibContext.activeBlocks.values().next().value) === null || _this$ibContext$activ3 === void 0 ? void 0 : _this$ibContext$activ3.ref;
        inst === null || inst === void 0 || inst.toggleTitleRename();
        event.preventDefault();
        return;
      }
    }, true);
  }
  beforeDestroy() {
    this.flushChanges.flush();
    this.ibContext.dispose();
  }
  getNewStepOfAtom(atomId) {
    const atom = this.atoms[atomId];
    // eslint-disable-next-line @typescript-eslint/naming-convention
    const _key = Date.now().toString(36);
    const step = {
      type: atomId,
      params: cloneDeep((atom === null || atom === void 0 ? void 0 : atom.defaultParams) || {}),
      _key
    };
    return step;
  }
  addStep(atomId) {
    this.flowSteps.push(this.getNewStepOfAtom(atomId));
    this.flushChanges();
  }
  get flushChanges() {
    this.flush();
    return debounce(() => {
      var _this$flowCtxBase$uc;
      (_this$flowCtxBase$uc = this.flowCtxBase.uc) === null || _this$flowCtxBase$uc === void 0 || _this$flowCtxBase$uc.notifyPageletsChange(0);
    }, 100);
  }
  render() {
    const h = arguments[0];
    return h("div", {
      "class": classNames('uc-propForm-item ucd-sfe'),
      "on": {
        ...{
          "!blur": this.flush
        }
      }
    }, [h(SimpleFlowStepList, {
      "attrs": {
        "steps": this.flowSteps
      }
    }), this.tempValue.debounce && h("div", {
      "class": "ucd-sfe-debounce",
      "style": ""
    }, [h("label", [h("input", {
      "class": "uc-checkbox",
      "attrs": {
        "type": "checkbox"
      },
      "domProps": {
        "checked": !!this.tempValue.debounce
      },
      "on": {
        "change": ev => {
          if (!ev.target.checked) {
            message.info('后续请在事件名右侧配置防抖');
          }
          this.$set(this.tempValue, 'debounce', !!ev.target.checked);
        }
      }
    }), ' 禁止重复触发'])])]);
  }
};
SimpleFlowEditor = __decorate([Component({
  name: 'SimpleFlowEditor',
  model: {
    prop: 'value',
    event: 'change'
  },
  props: {
    flowCtxBase: {
      required: true
    },
    value: {
      required: true
    },
    argumentsSchemas: {
      default: null
    }
  },
  components: {
    Draggable,
    FlowAtomSelector
  },
  mixins: [vueObjectEditorMixin({
    propName: 'value',
    eventName: 'change',
    tempVarName: 'tempValue',
    flushMethodName: 'flush',
    // 如果不失焦 停止修改3秒后提交
    throttleTimeout: 3000,
    throttleImpl: debounce,
    // 启动修改时不要触发
    leading: true
  })],
  provide() {
    return {
      [INJECT_SIMPLE_FLOW_EDITOR]: this,
      [INJECT_SIMPLE_FLOW_STEP_EDITOR]: null,
      [INJECT_SIMPLE_FLOW_STEP_LIST]: null
    };
  }
})], SimpleFlowEditor);
export default SimpleFlowEditor;
//# sourceMappingURL=SimpleFlowEditor.js.map
